export function setupMenu() {
  //ajustar top en mobile

  ajustarMenuMobile();

  var showmenu_btn = document.querySelectorAll(".menu_btn");
  for (const boton of showmenu_btn) {
    boton.addEventListener("click", function (e) {
      e.preventDefault();
      this.classList.toggle("open");
      //document.querySelector(".menu_mobile").classList.toggle("open");
      //document.querySelector(".menu_mobile_cover").classList.toggle("open");
      //document.querySelector("body").classList.toggle("menu_abierto");
      //  document.querySelector(".showmenu_btn").classList.toggle("open");
    });
  }

  //submenues
  // var submenues = document.querySelectorAll(
  //   ".header--container--menu li.menu-item-has-children"
  // );

  // for (const boton of submenues) {
  //   var link = boton.querySelector("a");

  //   const flecha = document.createElement("a");
  //   flecha.href = "javascript:void(0);";
  //   flecha.classList.add("menu-flecha");
  //   flecha.addEventListener("click", function (e) {
  //     e.preventDefault();
  //     boton.classList.toggle("submenu_abierto");
  //     return false;
  //   });
  //   link.after(flecha);
  // }

  //nuevo
  // const menu_cover = document.querySelector(".menu_mobile_cover");
  // menu_cover.addEventListener("click", function () {
  //   showmenu_btn[0].click();
  // });

  //menu
  var lastScrollTop = 0;
  function do_scroll_events() {
    var st = document.scrollingElement.scrollTop;
    if (st > 110) {
      //&& st > lastScrollTop
      document.querySelector("body").classList.add("scrolled");
    } else {
      document.querySelector("body").classList.remove("scrolled");
    }
    lastScrollTop = st;

    ajustarMenuMobile();
  }

  var scroll_doit;
  window.addEventListener("scroll", function () {
    do_scroll_events();
  });
  do_scroll_events();

  const menu_cerrar = document.querySelectorAll(".header__nav__cerrar");
  for (const item of menu_cerrar) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      body_el.classList.remove("body_submenu_active");
      header_el.classList.remove("submenu_active");

      const itemsmenu = document.querySelectorAll(
        ".header__nav__submenu__container"
      );

      for (const item_menu of itemsmenu) item_menu.classList.remove("active");

      html_el.classList.remove("no-scroll");
      body_el.classList.remove("no-scroll");
      if (tenia_scrolled) header_el.classList.add("scrolled");
    });
  }
}

function ajustarMenuMobile() {
  const header_el = document.querySelector("header.header");
  const menu_mobile_el = document.querySelector(".menu_mobile");
  // const rect = header_el.getBoundingClientRect();
  // menu_mobile_el.style.setProperty("--headerBottom", rect.bottom - 1 + "px");
}

const $menuHamburguesa = document.querySelectorAll(".menu_btn");
const $menuMobile = document.querySelectorAll(".menu_btn_mobile");
const $menuDesplegable = document.querySelectorAll(
  ".header--container--menu--desplegable"
);
const $seccionesBtn = document.querySelectorAll(".menu-item_flechita");
const $btnCerrar = document.querySelectorAll(".link_cerrar");
const $body = document.querySelectorAll("body");
//const $cover = document.querySelector(".header--container--menu--desplegable");
const $submenu = document.querySelectorAll(".menu-item-has-children");
const $submenuDesplegable = document.querySelector(
  ".header--container--menu--desplegable .sub-menu"
);
if ($submenu) {
  $submenu.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.target.parentNode
        .querySelector(".sub-menu")
        .classList.toggle("submenu_abierto");
    });
  });
}
const toggleMenu = () => {
  $menuDesplegable.forEach((btn) => btn.classList.toggle("show-menu"));
  $body.forEach((btn) => btn.classList.toggle("menu_abierto"));
};

$menuHamburguesa.forEach((btn) => btn.addEventListener("click", toggleMenu));
$btnCerrar.forEach((btn) => btn.addEventListener("click", toggleMenu));
$menuMobile.forEach((btn) => btn.addEventListener("click", toggleMenu));
